<template>
  <div>
    <v-dialog max-width="700px" persistent v-model="isOpen">
      <v-card>
        <v-card-title>Delivery</v-card-title>

        <v-form ref="formPOMDelivery" data-vv-scope="formPOMDelivery">
          <v-card-text class="pt-0">
            <v-container grid-list-md class="pb-0">
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="formData.delivery_expiry_date"
                    full-width
                    lazy
                    min-width="290px"
                    offset-y
                    ref="deliveryExpiryDate"
                    transition="scale-transition"
                    v-model="isDeliveryDatePickerOpen"
                    :disabled="
                      !!formData.successful_delivery_date ||
                      isSuccessfulDelivered
                    "
                  >
                    <v-text-field
                      label="Delivery Expiry Date"
                      prepend-icon="event"
                      readonly
                      clearable
                      slot="activator"
                      v-model="formData.delivery_expiry_date"
                      :rules="!isSuccessfulDelivered ? [rules.required] : []"
                      required
                      :disabled="
                        !!formData.successful_delivery_date ||
                        isSuccessfulDelivered
                      "
                    ></v-text-field>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="formData.delivery_expiry_date"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="isDeliveryDatePickerOpen = false"
                        color="primary"
                        flat
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="handleChangeDeliveryExpiryDate"
                        color="primary"
                        flat
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex md6 xs12>
                  <v-menu
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="formData.storage_expiry_date"
                    full-width
                    lazy
                    min-width="290px"
                    offset-y
                    ref="storageExpiryDate"
                    transition="scale-transition"
                    v-model="isStorageExpiryDatePickerOpen"
                    :disabled="
                      !!formData.successful_delivery_date ||
                      isSuccessfulDelivered
                    "
                  >
                    <v-text-field
                      label="Storage Expiry Date"
                      prepend-icon="event"
                      readonly
                      clearable
                      slot="activator"
                      v-model="formData.storage_expiry_date"
                      :rules="!isSuccessfulDelivered ? [rules.required] : []"
                      required
                      :disabled="
                        !!formData.successful_delivery_date ||
                        isSuccessfulDelivered
                      "
                    ></v-text-field>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="formData.storage_expiry_date"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="isStorageExpiryDatePickerOpen = false"
                        color="primary"
                        flat
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        @click="
                          $refs.storageExpiryDate.save(
                            formData.storage_expiry_date
                          )
                        "
                        color="primary"
                        flat
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    label="Notification for storage expiry date"
                    required
                    v-model="formData.is_notification_storage_expiry_date"
                    :disabled="
                      !!formData.successful_delivery_date ||
                      isSuccessfulDelivered
                    "
                  >
                  </v-checkbox>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    label="Elevator successfully delivered"
                    required
                    v-model="isSuccessfulDelivered"
                    :disabled="!!formData.successful_delivery_date"
                  >
                  </v-checkbox>
                </v-flex>
              </v-layout>

              <v-layout wrap justify-center>
                <v-flex md9 xs12>
                  <v-btn
                    block
                    color="primary"
                    @click="sendNotification"
                    :disabled="
                      !!formData.successful_delivery_date ||
                      isSuccessfulDelivered
                    "
                    :loading="isSendNotification"
                  >
                    Send notification
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="onCancel">Cancel</v-btn>
            <v-btn
              @click="onSave"
              color="primary"
              :disabled="!!formData.successful_delivery_date"
              :loading="isSave"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog max-width="450px" persistent v-model="dialogConfirm">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>Are you sure to cancel the changes?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
          <v-btn @click="onClose" color="primary" style="width: 85px">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="450px" persistent v-model="dialogStatus">
      <v-card>
        <v-card-title>
          <span class="headline">Alert</span>
        </v-card-title>
        <v-card-text>{{ errorMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogStatus = false" style="width: 85px">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { addMonths, startOfDay } from "date-fns";
import PurchaseOrderService from "../services/purchase.order.service.js";

export default {
  inject: ["$validator"],
  model: {
    prop: "open",
    event: "toggle",
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    poId: {
      type: String,
      required: true,
    },
    refetchData: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      purchaseOrderService: new PurchaseOrderService(),
      rules: {
        required: (v) => (v && v.trim().length > 0) || "It is required field",
      },
      isOpen: false,
      isDeliveryDatePickerOpen: false,
      isStorageExpiryDatePickerOpen: false,
      dialogConfirm: false,
      dialogStatus: false,
      errorMessage: "",
      formData: {
        delivery_expiry_date: "",
        is_notification_storage_expiry_date: false,
        storage_expiry_date: "",
        successful_delivery_date: "",
        is_manual_send_notification: false,
      },
      isSuccessfulDelivered: false,
      isSendNotification: false,
      isSave: false,
    };
  },
  methods: {
    allowedDates(date) {
      // Disable past dates
      const today = new Date();
      return startOfDay(date) >= startOfDay(today);
    },
    formatDate(date, isFormatUtc) {
      let format = "YYYY-MM-DD";
      if (isFormatUtc) {
        format = "YYYY-MM-DD[T00:00:00.000Z]";
      }

      return this.$morphDate(date, format);
    },
    fetchData() {
      this.purchaseOrderService.getDeliveryDetail(this.poId).then((res) => {
        this.formData = {
          delivery_expiry_date: res.data.delivery_expiry_date
            ? this.formatDate(res.data.delivery_expiry_date)
            : "",
          storage_expiry_date: res.data.storage_expiry_date
            ? this.formatDate(res.data.storage_expiry_date)
            : "",
          successful_delivery_date: res.data.successful_delivery_date
            ? this.formatDate(res.data.successful_delivery_date)
            : "",
          is_manual_send_notification:
            res.data.is_manual_send_notification || false,
          is_notification_storage_expiry_date:
            res.data.is_notification_storage_expiry_date || false,
        };
        this.isSuccessfulDelivered = !!res.data.successful_delivery_date;

        this.$nextTick(() => {
          this.isOpen = true;
        });
      });
    },
    validateThen(callback) {
      this.$validator.validate("formPOMDelivery.*").then((result) => {
        const extraValidated = this.$refs.formPOMDelivery.validate();
        if (result && extraValidated) {
          const data = {
            ...this.formData,
            delivery_expiry_date: this.formData.delivery_expiry_date
              ? this.formatDate(this.formData.delivery_expiry_date, true)
              : null,
            storage_expiry_date: this.formData.storage_expiry_date
              ? this.formatDate(this.formData.storage_expiry_date, true)
              : null,
            successful_delivery_date: this.isSuccessfulDelivered
              ? this.formatDate(new Date(), true)
              : null,
          };
          callback(data);
        }
      });
    },
    sendNotification() {
      this.validateThen((data) => {
        this.isSendNotification = true;
        this.editDelivery({
          ...data,
          is_manual_send_notification: true,
        });
      });
    },
    editDelivery(data) {
      this.purchaseOrderService.editDelivery(this.poId, data).then((res) => {
        if (res.data && res.data.statusCode === 200) {
          this.refetchData();
          this.onClose();
        } else {
          this.dialogStatus = true;
          this.errorMessage = res.data.message;
        }
        this.isSave = false;
        this.isSendNotification = false;
      });
    },
    onSave() {
      this.validateThen((data) => {
        this.isSave = true;
        this.editDelivery(data);
      });
    },
    onClose() {
      this.$emit("toggle", false);
      this.refetchData();
    },
    onCancel() {
      if (this.isSuccessfulDelivered) {
        this.onClose();
      } else {
        this.dialogConfirm = true;
      }
    },
    handleChangeDeliveryExpiryDate() {
      const deliveryDate = this.formData.delivery_expiry_date;
      this.$refs.deliveryExpiryDate.save(deliveryDate);

      const date = new Date(deliveryDate);
      const storeExpiryDate = addMonths(date, 2);
      this.formData.storage_expiry_date = this.formatDate(storeExpiryDate);
    },
  },
  watch: {
    open(value) {
      if (value) {
        this.fetchData();
      } else {
        this.$refs.formPOMDelivery.reset();
        this.$validator.reset();
        this.isOpen = false;
        this.dialogConfirm = false;
      }
    },
    isSuccessfulDelivered: {
      handler(value) {
        this.isSuccessfulDelivered = value;
        if (value) {
          this.formData.is_notification_storage_expiry_date = false;
        }
      },

      deep: true,
    },
  },
};
</script>
